// extracted by mini-css-extract-plugin
module.exports = {"root":"_3anpn","row":"_2Lxek","text":"_1zNJ-","date":"_1Ka0I","total":"_1gGKR","arrow":"_16lud"};